// 防抖
export function debounce(func, wait, immediate) {
    let timeout;
    return function(...args) {
      let context = this;
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        let callNow = !timeout;
        timeout = setTimeout(function() {
          timeout = null;
        }, wait);
        if (callNow) func.apply(context, args);
      } else {
        timeout = setTimeout(function() {
          func.apply(context, args);
        }, wait);
      }
    };
  }
  export function floatObj() {
    // 判断传入的值-是否为整数
    function isInteger(obj) {
      return Math.floor(obj) === obj;
    }
    // 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
    // @param floatNum { number } 小数
    // @return { object }
    // { times: 100, num: 314 }
    // 用于返回整数和倍数
    function toInteger(floatNum) {
      // 声明一个对象用来保存倍数和整数
      var ret = { times: 1, num: 0 };
      // 第一种情况：是整数
      if (isInteger(floatNum)) {
        // 把整数给 ret中的   num
        ret.num = floatNum;
        return ret; //  最后返回 ret
      }
      // 第二种情况-不是整数，
      var strfi = floatNum + ""; // 转为字符串  "0.1"
      var dotPos = strfi.indexOf("."); // 查询小数点
      var len = strfi.substr(dotPos + 1).length; //  获取小数点后的长度
      var times = Math.pow(10, len); // 放大多少倍
      var intNum = Number(floatNum.toString().replace(".", "")); // 返回 转为字符串  截取掉小数点  最后转为数字（整数）
      // 把获取到的倍数和整数存入对象中
      ret.times = times;
      ret.num = intNum;
      return ret;
    }
    // 核心方法，实现加减乘除运算，确保不丢失精度
    // 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
    // @param a { number } 运算数1
    // @param b { number } 运算数2
    // @param digits { number } 精度，保留的小数点数，比如 2, 即保留为两位小数
    // @param op { string } 运算类型，有加减乘除（add / subtract / multiply / divide）
    function operation(a, b, digits = 2, op) {
      // 获取倍数和整数的对象
      var o1 = toInteger(a);
      var o2 = toInteger(b);
      // 提取整数
      var n1 = o1.num;
      var n2 = o2.num;
      // 提取倍数
      var t1 = o1.times;
      var t2 = o2.times;
      // 获取最大倍数
      var max = t1 > t2 ? t1 : t2;
      var result = null; //
      switch (op) {
        case "add":
          if (t1 === t2) {
            // 两个小数位数相同
            result = n1 + n2; //
          } else if (t1 > t2) {
            // o1 小数位 大于 o2
            result = n1 + n2 * (t1 / t2);
          } else {
            // o1 小数位 小于 o2
            result = n1 * (t2 / t1) + n2;
          }
          return (result / max).toFixed(digits);
        case "subtract":
          if (t1 === t2) {
            result = n1 - n2;
          } else if (t1 > t2) {
            result = n1 - n2 * (t1 / t2);
          } else {
            result = n1 * (t2 / t1) - n2;
          }
          return (result / max).toFixed(digits);
        case "multiply":
          result = (n1 * n2) / (t1 * t2);
          return result.toFixed(2);
        case "divide":
          result = (n1 / n2) * (t2 / t1);
          return result.toFixed(digits);
      }
    }
    // 加减乘除的四个接口
    function add(a, b, digits) {
      return operation(a, b, digits, "add");
    }
    function subtract(a, b, digits) {
      return operation(a, b, digits, "subtract");
    }
    function multiply(a, b, digits) {
      return operation(a, b, digits, "multiply");
    }
    function divide(a, b, digits) {
      return operation(a, b, digits, "divide");
    }
    return {
      add: add,
      subtract: subtract,
      multiply: multiply,
      divide: divide
    };
  }
  export function parseNoteString(noteString) {
    if (/&[^_]*_/.test(noteString)) {
      const htmlString = noteString.replace(
        /&([a-zA-Z]+):([^_]+)_([^()]+)\(([^)]+)\)/g,
        function(match, styleType, color, font, content) {
          let styleString = "";
          if (styleType === "color") {
            styleString += `color:${color};`;
          }
          if (font === "fontW:bold") {
            styleString += "font-weight:bold;";
          }
          return `<span style="${styleString}">${content}</span>`;
        }
      );
      return `<p>${htmlString}</p>`;
    } else {
      const htmlString = noteString.replace(
        /&([a-zA-Z]+):?([^()]+)?\(([^)]+)\)&/g,
        function(match, styleType, label, content) {
          let styleString = "";
          if (styleType === "color") {
            styleString += `color:${label};`;
          } else if (styleType === "fontW") {
            if (label === "bold") {
              styleString += "font-weight:bold;";
            }
          }
          return `<span style="${styleString}">${content}</span>`;
        }
      );
      return `<p>${htmlString}</p>`;
    }
  }
  // 只能输入两位小数与整数
  export function integer(val) {
    // 清除除了数字和"."以外的字符
    let cleaned = val.replace(/[^\d.]/g, "");
    // 处理输入两个连续的零的情况
    if (cleaned.startsWith("00")) {
      cleaned = cleaned.slice(1); // 去掉第一个零
    }
    // 验证第一个字符是数字而不是"."，确保第一个字符不能是小数点
    cleaned = cleaned.replace(/^\./g, "");
    // 验证是否有多余的小数点，如果有，移除最后一个小数点
    if (cleaned.indexOf(".") !== cleaned.lastIndexOf(".")) {
      cleaned = cleaned.slice(0, -1);
    }
    // 只能输入两个小数
    cleaned = cleaned.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
  
    return cleaned;
  }

  //Google tag
  import formatTime from "@/filters/index.js";
  import axios from 'axios'
  // import { English } from "@/plugs/ChineseToEnglish.js";
  import store from "../store";
  function getBrowserInfo() {
    const ua = navigator.userAgent;
    let name = "Unknown";
    let version = "Unknown";
  
    // 检测浏览器名称和版本
    if (ua.includes("Chrome") && !ua.includes("Edg")) {
      name = "Google Chrome";
      const match = ua.match(/Chrome\/(\d+)/);
      if (match) version = match[1];
    } else if (ua.includes("Edg")) {
      name = "Microsoft Edge";
      const match = ua.match(/Edg\/(\d+)/);
      if (match) version = match[1];
    } else if (ua.includes("Firefox")) {
      name = "Mozilla Firefox";
      const match = ua.match(/Firefox\/(\d+)/);
      if (match) version = match[1];
    } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
      name = "Apple Safari";
      const match = ua.match(/Version\/(\d+)/);
      if (match) version = match[1];
    } else if (ua.includes("MSIE")) {
      name = "Internet Explorer";
      const match = ua.match(/MSIE (\d+)/);
      if (match) version = match[1];
    } else if (ua.includes("Trident")) {
      name = "Internet Explorer";
      version = "11";
    } else if (ua.includes("Opera") || ua.includes("OPR")) {
      name = "Opera";
      const match = ua.match(/(?:Opera|OPR)\/(\d+)/);
      if (match) version = match[1];
    }
  
    return { name, version };
  }

  async function TrackingPoint(english,chinese,browse_content) {
    const params = { english, chinese, browse_content };
    let url="/report/browse-log";
    if (process.env.NODE_ENV === 'production') {
      url="https://teapi.50pk.com/report/browse-log"
    }
    const { data: res } = await axios.post(url,params);
    if (res.code !== 0) {
      console.error("埋点接口错误：",res.message);
    }
  }
  async function getLoginMes(eventParams,platform) {
    const params = { 
      gid: 0, // 游戏id
      uid: eventParams.uid,
      sub_uid: '',
      lid: eventParams.lid, // 包链接id
      equipment_id: eventParams.equmentid, // 客户端设备号（imei、idfa）
      equipment_idfv: eventParams.equmentidfv, // 客户端重装标识
      platform: platform, // 平台(0-安卓,1-IOS,2-H5)
      access_token: window.localStorage.getItem('access_token'),
      rest: { test: 0 }, // 其他数据，包含客户端信息的 json 字符串
      apptype: 'gamebox',
    };
    const { data: res } = await axios.post('/box/login',params);
    if (res.code === 0) {
      window.sessionStorage.setItem('loginMes', true)
    }
  }
  export function Analytics(event, eventName, eventData, timestamp) {
    let obj = store.state;
    let environment = "";
    let platform = "";
    let isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.userAgent.match(/(Macintosh)/) && navigator.maxTouchPoints >= 1));
    if (window.WebViewJs) {
      environment = "Android";
      platform = "Android端（0）";
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.sendLoginSuccessAccessToken
    ) {
      environment = "IOS";
      platform = "iOS端（1）";
    }else if(isMobile||isiPad){
      if (isIOS ||(navigator.userAgent.match(/(Macintosh)/) && navigator.maxTouchPoints >= 1)) {
        environment = "Web"; // 默认 Web 平台
        platform = "iOS浏览器（1）";
      } else {
        environment = "Web"; // 默认 Web 平台
        platform = "安卓浏览器（0）";
      }
    }else {
      environment = "Web"; // 默认 Web 平台
      platform = "Web（2）";
    }
    // 移除undefined的参数
    for (let key in eventData) {
      if (eventData[key] === undefined) {
        delete eventData[key];
      }
    }
    if (obj.uid == 0 && environment == "Web") return; // 网页不登录不上报
    let time = timestamp ? timestamp : Date.now();
    // 构建事件数据对象
    const eventParams = {
      ...eventData, // 包括自定义参数
      time: formatTime.formatTime(time, "yyyy.MM.dd hh:mm:ss"),
      ip: obj.phone_ip, //网络ip
      uid: obj.uid + "",
      equmentid: obj.requestParams.equmentid, //设备
      user_platform: platform,
      environment: environment, //系统环境
      phone_version: obj.requestParams.phone_version + "", //操作系统版本
      version: obj.requestParams.version + "", //应用版本
      browser_name: getBrowserInfo().name, //浏览器名称
      browser_version2: getBrowserInfo().version, //浏览器版本
      lid: obj.requestParams.lid + "",
      sdk_gid:obj.sdk_gid + "",//SDK跳转盒子携带的gid
    };
    // console.log(event, eventName,English(eventName), eventParams);
    // 执行跟踪事件代码
    // gtag(event, eventName, eventParams);
    window.collectEvent(English(eventName), eventParams);
    TrackingPoint(English(eventName),eventName,JSON.stringify(eventParams))
    if (eventName==="注册成功" || eventName==="登陆成功" || eventName==="修改密码修改-确认") return

    let ActiveUsers = JSON.parse(window.localStorage.getItem('ActiveUsers'))||[]
    const index = ActiveUsers.findIndex(item => item.uid == obj.uid);
    const ActiveUsersTime=formatTime.formatTime(Date.now(), "yyyy.MM.dd")
    if (index === -1) {
      ActiveUsers.push({ time:ActiveUsersTime, uid:obj.uid })
      window.collectEvent('box_daily_active_users', eventParams);
      TrackingPoint('box_daily_active_users','盒子每日活跃用户',JSON.stringify(eventParams))
      getLoginMes(eventParams,obj.platform)
    }else if (index !==-1 && ActiveUsers[index].time !== ActiveUsersTime) {
      ActiveUsers[index].time = ActiveUsersTime;
      window.collectEvent('box_daily_active_users', eventParams);
      TrackingPoint('box_daily_active_users','盒子每日活跃用户',JSON.stringify(eventParams))
      getLoginMes(eventParams,obj.platform)
    }
    window.localStorage.setItem('ActiveUsers',JSON.stringify(ActiveUsers));
  }
  // 版本号判断
  export function compareVersions(targetVersion) {
    let version = store.state.requestParams.version;
    // 将版本号转换为数字数组
    const current = version.split(".").map(num => parseInt(num, 10));
    const target = targetVersion.split(".").map(num => parseInt(num, 10));

    for (let i = 0; i < Math.max(current.length, target.length); i++) {
        const currentPart = current[i] || 0;
        const targetPart = target[i] || 0;

        // 当前部分 > 目标部分 → 满足条件
        if (currentPart > targetPart) return true;
        // 当前部分 < 目标部分 → 不满足条件
        if (currentPart < targetPart) return false;
        // 如果相等，继续比较下一位
    }

    // 所有部分都相等 → 也满足条件
    return true;
  }